<template>
  <div class="job-info">
    <div class="job-info-header">
      <div class="job-info-left">
        <div class="job-title t-disp-4">{{ jobDetail.jobAdName }}</div>
        <div v-if="device === 'pc'" class="job-title-sm">
          <div class="job-title-sm-item">{{ jobDetail.locIdText }} {{ jobDetail.hotelBrandNameText ?
            `，${jobDetail.hotelBrandNameText}` : '' }} </div>
          <div class="job-title-sm-item">{{ jobDetail.innerChannelClassificationTwoText }}</div>
        </div>
      </div>
      <jobButton v-if="device === 'pc'" @goDetail="goDetail"></jobButton>
    </div>

    <div class="job-info-scroll">
      <div v-if="device === 'mb'" class="job-section store-section">
        <div class="store-section-img">
          <img class="job-img" :src="brandMap[jobDetail.hotelBrandName] || job_logo" alt="" />

        </div>
        <div class="store-section-left">
          <div class="job-store t-disp-6">{{ jobDetail.hotelBrandNameText }}</div>
          <span class="job-address"> {{ jobDetail.detailAddress || '-' }} </span>
        </div>
        <div class="store-section-right" @click="copyToClipboard(jobDetail.detailAddress)">
          <img :src="copy" alt="" width="20" height="20" />
        </div>
      </div>

      <div class="job-section job-info-detail active">
        <div class="section-header">
          <div class="section-title t-disp-9">{{ $t('searchJob.jobInformation') }}</div>
        </div>
        <div class="section-content-scroll">
          <div class="section-content">
            <div class="job-item">
              <div class="job-label">{{ $t('searchJob.jobCode') }}</div>
              <div class="job-value">{{ jobDetail.jobAdCode || '-' }}</div>
            </div>
            <div class="job-item">
              <div class="job-label">{{ $t('searchJob.jobType') }}</div>
              <div class="job-value">{{ jobDetail.innerChannelClassificationTwoText || '-' }}</div>
            </div>
            <div class="job-item">
              <div class="job-label">{{ $t('searchJob.releaseDate') }}</div>
              <div class="job-value">{{ jobDetail.postDate || '-' }}</div>
            </div>
            <div v-if="device === 'pc'" class="job-item">
              <div class="job-label">{{ $t('searchJob.jobAddress') }}</div>
              <div class="job-value">
                {{ jobDetail.detailAddress || '-'}}
                <div class="icon-copy" @click="copyToClipboard(jobDetail.detailAddress)">
                  <img :src="copy" alt="" width="24" height="24" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="job-section" :class="`${sectionOpen.responsibilities && 'active'}`">
        <div class="section-header" @click="toggleSection('responsibilities')">
          <div class="section-title section-title-pc" :class="device === 'mb' && 't-disp-9'">{{
            $t('searchJob.jobResponsibilities') }}</div>
          <div class="section-line"></div>
        </div>
        <div class="section-content-scroll">
          <div class="section-content">
            {{ jobDetail.duty }}
          </div>
        </div>
      </div>

      <div class="job-section" :class="`${sectionOpen.qualification && 'active'}`">
        <div class="section-header" @click="toggleSection('qualification')">
          <div class="section-title section-title-pc" :class="device === 'mb' && 't-disp-9'">{{
            $t('searchJob.jobQualification') }}</div>
          <div class="section-line"></div>
        </div>
        <div class="section-content-scroll">
          <div class="section-content">
            {{ jobDetail.require }}
          </div>
        </div>
      </div>

      <div class="job-section why-section" :class="`${sectionOpen.why && 'active'}`">
        <div class="section-header" @click="toggleSection('why')">
          <div class="section-title section-title-pc" :class="device === 'mb' && 't-disp-9'">
            {{ $t('searchJob.whyHilton') }}
          </div>
          <div class="section-line"></div>
        </div>
        <div class="section-content-scroll">
          <div class="section-content">{{ $t('searchJob.whyHiltonDesc') }}</div>
        </div>
      </div>

      <div class="video-section" v-if="jobDetail.videoJD">
        <div class="job-video-title t-disp-3">{{ $t('searchJob.welcome') }}</div>
        <div class="job-video">
          <div v-if="device === 'pc'" @click="changePlayVideo">
            <img  class="video-img" :src="videoImg" alt=""  />
            <img class="play-icon" :src="GM_EP_Video" alt="" width="39" height="39">
          </div>
          <video v-else ref="videoRef" width="100%" height="100%" controls :poster="videoImgMb" :src="jobDetail.videoJD">
            <track kind="captions" src="data:text/vtt;base64," srclang="en" label="No captions">
          </video>
        </div>
      </div>
    </div>

    <div class="job-button" v-if="device === 'mb'">
      <Button color="#c028b9" type="primary" @click="goDetail">{{ $t('searchJob.jobApplyNow') }}</Button>
    </div>

    <teleport to="body">
      <VideoPlay :show="showVideo" :videoUrl="playVideo" :posterUrl="posterUrl" @closeVideo="closeVideoHandle">
      </VideoPlay>
    </teleport>
  </div>
</template>

<script setup>
import job_logo from "@/assets/image/logo.png";
import copy from "@/assets/image/searchJob/copy.svg";
import videoImgMb from "@/assets/image/searchJob/video.png";
import videoImg from "@/assets/image/footer/footer-logo.webp";
import GM_EP_Video from '@/assets/image/home/GM-EP-Video.png'

import { ref, reactive, inject, defineProps } from "vue";
import { Button, showToast } from "vant";
const device = inject("device");
// import i18n from '@/plugins/
import { useI18n } from 'vue-i18n';
import jobButton from "./jobButton.vue";
import VideoPlay from "@/components/VideoPlay.vue";
import brandMap from './brandMap.js'

const { t, locale } = useI18n();

const props = defineProps({
  jobDetail: {
    type: Object,
    default:{}
  }
})

const sectionOpen = reactive({
  responsibilities: false,
  qualification: false,
  why: false,
});

const toggleSection = (key) => {
  sectionOpen[key] = !sectionOpen[key];
};
const copyToClipboard = async (e) => {
  try {
    await navigator.clipboard.writeText(e);
    showToast(t('searchJob.copySuccess'));
  } catch (err) {
    console.error('Failed to copy: ', err);
    showToast(t('searchJob.copyFail'));
  }
};

const showVideo = ref(false);
const playVideo = ref("");
const posterUrl = ref("");

const changePlayVideo = (item) => {
  showVideo.value = true;
  playVideo.value = props.jobDetail.videoJD;
  posterUrl.value = videoImg;
};
const closeVideoHandle = () => {
  showVideo.value = false;
  playVideo.value = null;
  posterUrl.value = null;
};

const goDetail = () => {
  let lang = ''
  if (locale.value === 'en') {
    lang = "en_US"
  } else {
    lang = "zh_CN"
  }
  window.location.href = `${import.meta.env.VITE_APP_APP_DETAIL}?fromPage=job&jobAdId=${props.jobDetail.jobAdId}&lang=${lang}`
}
</script>

<style lang="scss" scoped>
.job-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--hc-color--offwhite-100);

  &-scroll {
    flex: 1;
    height: 0;
    overflow-y: auto;
  }

  .job-title {
    margin-bottom: 12px;
    font-weight: 500;
  }

  .job-title-sm {
    display: flex;
    align-items: center;
    &-item {
      &::after {
        display: inline-block;
        content: "";
        width: 1px;
        height: 12px;
        margin: 0 16px;
        background-color: rgba(0, 0, 0, 0.4);
      }
      &:last-child::after {
        display: none;
      }
    }
  }

  .job-section {
    margin-bottom: 8px;
    padding: 12px;
  }

  .store-section {
    display: flex;
    align-items: center;

    &-img {
      display: flex;
      align-items: center;

      img {
        margin-right: 16px;
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 4px;
        border: 1px solid #0000000d;
      }
    }

    &-left {
      flex: 1;
    }

    &-right {
      padding-left: 12px;
      cursor: pointer;
    }

    .job-store {
      font-size: 1.14rem;
      color: #000000;
    }

    .job-address {
      font-size: 0.85rem;
      color: #4d5660;
    }
  }

  .section-title {
    font-weight: 500;
  }

  .section-line {
    display: none;
  }

  .section-content {
    font-size: 0.85rem;
    white-space: pre-line;
    line-height: 1.75rem;
    padding-left: 10px;
  }

  ul {
    list-style: disc;
    padding-left: 1.5em;
    line-height: 1.66;
  }

  .job-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 4px;
    font-size: 0.85rem;
  }

  .job-label {
    color: #4d5660;
  }

  .job-value {
    color: #000;
  }

  .job-video-title {
    font-size: 1.715rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 0;
    margin: 0;
    background-color: var(--hc-color--offwhite-200);
  }

  .job-video {
    width: 100%;
    height: 53.7vw;
    cursor: pointer;
    background-color: var(--hc-color--darkblue);;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .video-img {
      // width: 100%;
      width: 300px;
      // height: 100%;
    }
    .play-icon{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

@media (min-width: 768px) {
  .job-info {
    padding: 72px 0;

    .job-info-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 125px 56px;
      .job-info-left{
        flex: 1;
        padding-right: 20px;
      }
    }

    .job-info-scroll {
      padding: 0 125px;
    }

    .job-section {
      padding:  0;
      margin-bottom: 0;
    }
    .section-content {
      font-size: 1rem;
    }
    .job-info-detail {
      padding: 44px;
      background-color: #fff;
      .section-header {
        margin-bottom: 40px;
        font-size: 1.75rem;
      }

      .section-content {
      
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
      }

      .job-item {
        flex-direction: column;
        align-items: flex-start;
        justify-content: start;
        font-size: 1.125rem;
      }

      .job-value {
        display: flex;
        align-items: center;

        .icon-copy {
          padding-left: 16px;
          cursor: pointer;
        }
      }
    }

    .section-title-pc {
      font-size: calc(20rem / 16);
      line-height: 2rem;
      color: #000000;
      margin-bottom: 16px;
      margin-top: 54px;
    }
    
    .video-section {
      margin-top: 54px;
      height: 320px;
      display: flex;
      align-items: center;
      background-color: #fff;
      .section-header {
        display: none;
      }

      .section-content {
        display: flex;
        height: 315px;
      }

      .job-video-title {
        flex: 1;
        width: 0;
        height: 100%;
        font-size: 2.75rem;
      }

      .job-video {
        width: 560px;
        height: 100%;
      }
    }
  }
}

@media (max-width: 767px) {
  .job-info {
    margin: 0;

    .job-title {
      max-width: 90%;
    }

    &-header {
      padding: 20px 20px 0 20px;
    }

    &-scroll {
      padding: 0 20px 20px;
    }
  }

  .job-section {
    background-color: #fff;

    .section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .section-line {
        display: block;
        width: 12px;
        height: 12px;
        position: relative;
        transition: transform 0.3s ease;
        $w: 1px;

        &::before,
        &::after {
          content: "";
          position: absolute;
          background: #002f61;
          transition: all 0.3s ease;
        }

        &::before {
          top: 50%;
          left: 0;
          width: 100%;
          height: $w;
          border-radius: $w;
          transform: translateY(-50%);
        }

        &::after {
          top: 0;
          left: 50%;
          width: $w;
          height: 100%;
          border-radius: $w;
          transform: translateX(-50%);
        }
      }
    }

    .section-content-scroll {
      overflow: hidden;
      max-height: 0;
      transition: max-height 0.4s ease;
    }

    .section-content {
      padding-top: 16px;
    }

    &.active {
      .section-line {
        transform: rotate(180deg);
        &::after {
          opacity: 0;
        }
      }
      .section-content-scroll {
        max-height: 1000px;
      }
    }
  }
  .video-section{
      .job-video {
          background-color: unset;
        }
  }
  .job-button {
    padding: 16px 20px;
    border-top: 1px solid #0000000d;
    .van-button {
      width: 100%;
      border-radius: 0;
    }
  }
}
</style>
